import { Route, Routes } from 'react-router-dom';
import { cn } from 'utils/helpers';
import { Error } from 'pages';

import CardWeb from './CardWeb';
import CardPreview from './CardPreview';

// eslint-disable-next-line react-refresh/only-export-components
const ROUTES = [
  {
    to: '/',
    element: () => <CardWeb />,
    index: true,
  },
  {
    to: '/preview',
    element: () => <CardPreview />,
  },
];

const _Card = () => (
  <div
    className={cn(
      'w-full',
      'h-full',
      'min-h-screen',
      'sm:py-[45px]',
      'sm:px-0',
      'sm:bg-[#F8FBFD]',
      'bg-[#FFFFFF]',
      'py-0',
      'px-0',
      'relative',
      'flex',
      'flex-col',
      'items-center',
    )}
  >
    <Routes>
      {ROUTES.map((route, index) => (
        <Route
          key={index}
          path={route.to}
          element={route.element?.()}
          index={route.index}
        />
      ))}
      <Route path="*" element={<Error />} />
    </Routes>
  </div>
);

export default _Card;
